// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function SparkleIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M24.698 16.133 18.25 13.75l-2.375-6.452a1.99 1.99 0 0 0-3.735 0L9.75 13.75l-6.453 2.375a1.99 1.99 0 0 0 0 3.735l6.453 2.39 2.375 6.453a1.99 1.99 0 0 0 3.735 0l2.39-6.453 6.453-2.375a1.99 1.99 0 0 0 0-3.735l-.005-.008Zm-7.573 4.395a.998.998 0 0 0-.593.592L14 27.981l-2.527-6.856a1.002 1.002 0 0 0-.598-.598L4.019 18l6.856-2.527a1 1 0 0 0 .598-.598L14 8.019l2.527 6.856a1 1 0 0 0 .593.592L23.981 18l-6.856 2.527ZM18 5a1 1 0 0 1 1-1h2V2a1 1 0 1 1 2 0v2h2a1 1 0 0 1 0 2h-2v2a1 1 0 0 1-2 0V6h-2a1 1 0 0 1-1-1Zm13 6a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-2 0v-1h-1a1 1 0 0 1 0-2h1V9a1 1 0 1 1 2 0v1h1a1 1 0 0 1 1 1Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
